export const isEmail = (email) => {
  const parts = email.split('@');

  if (parts.length !== 2) {
    return false;
  }

  return parts[0].length > 0 && parts[1].length > 0;
};

export const isNotEmail = (email) => !isEmail(email);
export const hasComma = (str) => str && str.includes(',');

export const isBlank = (str) => !str || (str && !str?.trim());

export const isZip = (postalCode, countryCode) => {
  let postalCodeRegex;
  switch (countryCode) {
    case 'US':
      postalCodeRegex = /^([0-9]{5})(?:[-\s]*([0-9]{4}))?$/;
      break;
    case 'CA':
      postalCodeRegex = /^([A-Z][0-9][A-Z])\s*([0-9][A-Z][0-9])$/;
      break;
    default:
      postalCodeRegex = /^(?:[A-Z0-9]+([- ]?[A-Z0-9]+)*)?$/;
  }
  return postalCodeRegex.test(postalCode);
};

export const isCurrency = (value) => {
  const regex = /^\d+(?:\.\d{0,2})$/;
  return regex.test(value);
};

export const required = (value) => (value ? undefined : 'Required');
export const lessThanOtherDate =
  (otherDate, label, otherDateLabel) => (value, values) =>
    value &&
    Object.values(values)[0][otherDate] &&
    value >= Object.values(values)[0][otherDate]
      ? `${label} must be before ${otherDateLabel}`
      : undefined;
export const minDate = (min, label) => (value) =>
  value && value < min ? `${label} cannot be in the past` : undefined;
export const maxLength = (max) => (value) =>
  value && value.length > max ? `Must be ${max} characters or less` : undefined;
export const maxLength255 = maxLength(255);
export const maxLength20 = maxLength(20);
export const maxLength50 = maxLength(50);

export const isNumber = (value) =>
  /^\s*\d+\s*$/.test(value) ? undefined : 'Please enter a valid number';
